<template>
  <ts-loading-banner :loading="waiting">
    <div class="tw-space-y-4">
      <div class="row">
        <div class="col-6">
          <label class="required">{{
            $t("certificateOperationPrint.requestDate")
          }}</label>
          <a-date-picker
            v-model="requesting_date"
            :allowClear="false"
            style="width: 100%"
            placeholder="DD-MM-YYYY"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            @change="onChangeRequestDate"
            :class="{
              'is-invalid': errors.has('requesting_date'),
            }"
          />
          <div class="invalid-feedback" v-if="errors.has('requesting_date')">
            {{ errors.first("requesting_date") }}
          </div>
        </div>
        <div class="col-6">
          <label class="col-md-12">{{ $t("search") }}</label>
          <div class="col-md-12">
            <a-input
              type="text"
              v-model="search_certificate"
              placeholder="candidate|certificate number|skill level|certificate type"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="overflow-auto col-md-12"
          style="max-height: 500px; min-height: 100px"
        >
          <a-table
            size="small"
            :columns="columns"
            :row-key="(certificates) => certificates.certificate_id"
            :data-source="certificates"
            :row-selection="{ onChange: checkItem }"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'name'">
                sad
                {{ record.fname_en }}
              </template>
            </template>
          </a-table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 tw-flex tw-justify-end tw-space-x-3">
          <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t("cancel") }}
          </ts-button>
          <!-- <ts-button
            v-if="!isUpdate"
            color="primary"
            outline
            :waiting="waiting"
            :disabled="waiting"
            @click.prevent="onSaveAddNew"
          >
            {{ $t("saveAddNew") }}</ts-button
          > -->
          <ts-button
            v-if="!isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onSave"
            >{{ $t("save") }}</ts-button
          >
          <ts-button
            v-if="isUpdate"
            :waiting="waiting"
            :disabled="waiting"
            color="primary"
            @click.prevent="onUpdate"
            >{{ $t("update") }}</ts-button
          >
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { debounce, isEmpty } from "lodash";
import { Errors } from "form-backend-validation";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  name: "certificateOperationPrintForm",
  data() {
    return {
      waiting: false,
      table_loading: false,
      errors: new Errors(),
      certificates: [],
      search_certificate: "",
      requesting_date: moment().format("DD-MM-YYYY"),
      model: {
        candidates: [],
      },
    };
  },
  computed: {
    ...mapState("academic/certificateOperationPrint", [
      "edit_data",
      "formViewDatas",
    ]),

    certificateLists() {
      return this.certificates;
    },
    isUpdate() {
      return !isEmpty(this.edit_data);
    },

    columns() {
      return [
        {
          title: this.$t("certificateOperationPrint.nameEn"),
          dataIndex: "candidate_name_en",
        },
        {
          title: this.$t("certificateOperationPrint.certificateNumber"),
          dataIndex: "certificate_number",
        },
        {
          title: this.$t("certificateOperationPrint.levelSkill"),
          dataIndex: "level_skill_name",
        },
        {
          title: this.$t("certificateOperationPrint.certType"),
          dataIndex: "cert_type_name",
        },
      ];
    },
  },
  async created() {
    await this.setEditData();
    await this.fetchFormViewModel({ index: undefined });
  },
  methods: {
    ...mapActions("academic/certificateOperationPrint", ["getFormViewData"]),
    async fetchFormViewModel({ index }) {
      this.waiting = true;
      await this.getFormViewData({
        index: index,
        params: {
          search_certificate: this.search_certificate,
        },
      });
      this.certificates = this.formViewDatas["certificate"];
      this.waiting = false;
    },
    checkItem(value) {
      this.model.candidates = [];
      value.forEach((e) => {
        var candidate_certificate = this.certificates.find(
          (el) => el.certificate_id == e
        );
        this.model.candidates.push({
          candidate_id: candidate_certificate.candidate_id,
          certificate_id: candidate_certificate.certificate_id,
          is_approved: false,
          approved_by: null,
          approved_date: null,
          is_printed: false,
          reach_candidate: false,
          requesting_date: this.requesting_date,
          minute_meeting_date: candidate_certificate.exam_date,
        });
      });
    },

    onChangeRequestDate(dateString) {
      this.requesting_date = dateString;
    },

    async onSave() {
      this.waiting = true;
      this.$store
        .dispatch("academic/certificateOperationPrint/store", this.model)
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("fetchData");
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/certificateOperationPrint/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearEdit();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    async onUpdate() {
      this.waiting = true;
      this.$store
        .dispatch("academic/certificateOperationPrint/update", {
          id: this.edit_data.printing_id,
          data: this.model,
        })
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .catch((error) => {
          this.$notify({ type: "errors", text: error.message });
          this.errors = new Errors(error.errors);
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearEdit() {
      this.model.candidates = [];
      this.requesting_date = moment().format("DD-MM-YYYY");
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.certificate_id = this.edit_data.certificate_id;
        this.requesting_date = this.edit_data.requesting_date;
        this.model.is_approved = this.edit_data.is_approved;
        this.model.is_printed = this.edit_data.is_printed;
        this.model.reach_candidate = this.edit_data.reach_candidate;
      }
    },
    certificateType() {
      if (this.model.certificate_id) {
        let certificateData = this.certificates.find(
          (e) => e.certificate_id == this.model.certificate_id
        );
        this.model.certificate_type = certificateData.cert_type_id;
        this.model.minute_meeting_date = certificateData.exam_date;
      }
    },
  },
  watch: {
    search_certificate: debounce(function () {
      this.fetchFormViewModel({ index: undefined });
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
</style>